const kinds = {
    fill: '',
    outline: 'outline',
    link: 'link',
};
const themes = {
    action: 'action',
    error: 'error',
    dark: 'dark',
};
const sizes = {
    small: 'small',
    large: '',
};
const setTheme = (c) => {
    if (!c) {
        return '-action';
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return themes[c] ? `-${themes[c]}` : '';
};
const setType = (t) => {
    if (t === 'fill' || !t) {
        return '';
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return kinds[t] ? `-${kinds[t]}` : '';
};
const setSize = (s) => {
    if (s === 'large') {
        return '';
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return sizes[s] ? ` btn-${sizes[s]}` : '';
};
const setState = ({ isDisabled, isProgress, isActive }) => {
    const c = [];
    if (isDisabled) {
        c.push(' is-disabled');
    }
    if (isProgress) {
        c.push(' is-progress');
    }
    if (isActive) {
        c.push(' is-active');
    }
    return c.join(' ');
};
const setIsWide = (w) => (w ? ' btn-wide' : '');
const setIcon = (icon, placement, childrenCount) => {
    if (icon) {
        let base = ' btn-icon';
        if (childrenCount && placement) {
            base += ` btn-icon-${placement}`;
        }
        return base;
    }
    return '';
};
const btnClassFormat = ({ theme, kind, size, isWide, icon, isProgress, isDisabled, isActive, iconPlacement, childrenCount, }) => {
    const format = `b-btn${setTheme(theme)}${setType(kind)}${setSize(size)}${setIsWide(isWide)}${setIcon(icon, iconPlacement, childrenCount)}${setState({
        isDisabled,
        isProgress,
        isActive,
    })}`;
    return format;
};
export default btnClassFormat;
